<template>
    <div class="quantity-input-container">
        <input
            ref="quantityInput"
            type="text"
            inputmode="decimal"
            class="quantity-input"
            :value="quantity"
            @focus="handleFocus"
            @keydown="filterInput"
            @input="handleInput"
        />
    </div>
</template>

<script>
    import { handleFormatQuantityConsumedToString } from "@/views/pages/operator/utils";
    import { mapGetters } from "vuex";

    export default {
        props: {
            newQuantity: {
                type: Number,
                default: 0
            },
            closeKeyboard: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters("app", ["flagShowModalPin"])
        },
        data: () => ({ quantity: "0" }),
        mounted() {
            setTimeout(() => this.setInputFocus(), 1000);
        },
        watch: {
            newQuantity(value) {
                const formattedQtd =
                    typeof this.quantity === "string"
                        ? this.quantity.replace(/\./g, "").replace(",", ".")
                        : this.quantity;
                let totalQtd = Number(formattedQtd) + value;

                if (totalQtd < 0) totalQtd = 0;

                this.quantity =
                    totalQtd % 1 === 0 ? String(totalQtd) : String(totalQtd).replace(".", ",");
                this.$emit("setQuantityValue", this.quantity);
            },
            closeKeyboard(value) {
                value && this.setInputBlur();
            },
            flagShowModalPin() {
                this.setInputFocus();
            }
        },
        methods: {
            setInputFocus() {
                !this.closeKeyboard && !this.flagShowModalPin && this.$refs.quantityInput?.focus();
            },
            setInputBlur() {
                this.$refs.quantityInput?.blur();
            },
            handleFocus(event) {
                if (this.quantity === "0") {
                    this.$nextTick(() => event.target.select());
                }
            },
            filterInput(event) {
                const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowUp",
                    "ArrowDown",
                    "Home",
                    "End",
                    "Tab"
                ];

                if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) return;

                if (event.key === "," || event.key === ".") {
                    const value = String(event.target.value).replace(/\./g, ",");

                    if (value.includes(",")) event.preventDefault();

                    return;
                }

                if (!/^\d$/.test(event.key)) event.preventDefault();
            },
            handleInput(event) {
                const input = event.target;
                const cursorPosition = input.selectionStart ?? 0;
                const normalized = handleFormatQuantityConsumedToString(input.value);

                this.quantity = normalized;
                this.$emit("setQuantityValue", normalized);

                this.$nextTick(() => {
                    if (!this.$refs.quantityInput) return;

                    const newCursor = this.resolveCursorPosition(
                        input.value,
                        normalized,
                        cursorPosition
                    );

                    this.$refs.quantityInput.setSelectionRange(newCursor, newCursor);
                });
            },
            resolveCursorPosition(oldValue, newValue, oldCursor) {
                const normalizedBefore = handleFormatQuantityConsumedToString(
                    oldValue.slice(0, oldCursor)
                );

                return Math.min(normalizedBefore.length, newValue.length);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .quantity-input-container {
        width: 100%;

        .quantity-input {
            width: 100%;
            height: 50px;
            border: none !important;
            background: transparent;
            text-align: center;
            font-weight: 600;
            font-size: 36px;
            line-height: 50px;
            color: #4c4541;

            &:focus {
                outline: 0;
            }
        }
    }

    @media (max-width: 768px) {
        .quantity-input-container {
            .quantity-input {
                font-size: 60px;
            }
        }
    }

    @media (max-width: 593px) {
        .quantity-input-container {
            .quantity-input {
                height: 36px;
                font-size: 26px !important;
                line-height: 36px !important;
            }
        }
    }
</style>
